import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { keyframes } from "styled-components";

const loading = keyframes`
    0% {
        transform: rotate(0deg)
    }
    100% {
        transform: rotate(360deg)
    }
`;

const Loading = styled.div`
    margin: auto;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 6px solid #B4B3BC;
    border-top-color: rgb(210, 34, 42);

    animation: ${loading} 1.0s linear infinite;
`;

const LMask = styled.div`
    min-height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-conent: center;
    justify-self: center;
`;

const LoadingContainer = styled.div`
    margin: auto;
    .h4 {
        position: relative;
        color: #d2222a;
        padding-top: 1rem;
        font-style: italic;
        text-align: center;
    }
`;

const Overlay = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(255,255,255,0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    justify-self: center;
`;

class LoadingComponent extends Component {
    render() {
        if(this.props.isOverlay) {
            return  this.props.isLoading ? (
                <Overlay>
                    <LoadingContainer>
                        <Loading />
                        <div className="h4" dangerouslySetInnerHTML={{__html: this.props.text}} />
                    </LoadingContainer>
                </Overlay>
            ) : <div/>;
        } else {
            return this.props.isLoading ? (
                <LMask>
                    <LoadingContainer>
                        <Loading />
                        <div className="h4" dangerouslySetInnerHTML={{__html: this.props.text}} />
                    </LoadingContainer>
                </LMask>
            ) : this.props.children;
        }
    }
}

LoadingComponent.propTypes = {
    isLoading: PropTypes.bool,
    text: PropTypes.string,
    isOverlay: PropTypes.bool,
    children: PropTypes.any
};

LoadingComponent.defaultProps = {
    isLoading: true,
    text: "",
    isOverlay: false
};

export default LoadingComponent;